import React from "react";
import { Transition } from "@headlessui/react";
import { cn } from "@utils";

const SkeletonLoader = ({ show }) => {
  return (
    <Transition
      show={show}
      appear
      enter="transition-opacity duration-700"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        className="row-start-1 col-start-1 z-20
          flex flex-col gap-2 pointer-events-none
          backdrop-blur-sm mb-5"
      >
        <div className="flex gap-4 h-5 w-full">
          <div className="h-full bg-zinc-300/40 rounded-lg w-12 animate-pulse-slow" />
          <div className="h-full bg-zinc-300/40 rounded-lg w-full animate-pulse-slow-delay-1" />
        </div>
        <div className="flex gap-4 h-5 w-full pl-8">
          <div className="h-full bg-zinc-300/40 rounded-lg w-full animate-pulse-slow-delay-2" />
        </div>
      </div>
    </Transition>
  );
};

export default SkeletonLoader;
